import { mutations } from "@/graphql";
import { useMutation } from "@apollo/client/react";
import { useCallback, useState } from "react";
import ReactGA from "react-ga4";

/**
 * Custom hook to handle forgot password functionality.
 * @param onCompleted
 * @param {Function} [onError] - Callback function to be called when an error occurs during the mutation.
 * @returns {{submit: Function, isSubmitting: boolean, resetSuccess: boolean}} - The function to submit the forgot password request, the loading state, and the success state.
 */
export function useForgotPassword(
  onCompleted: (_data?: any) => void = () => {},
  onError: (_error?: any) => void = () => {},
) {
  const [resetSuccess, setResetSuccess] = useState(null);
  const [userNotFound, setUserNotFound] = useState(null);

  const [comForgetPassword, { loading }] = useMutation<any>(
    mutations.forgotPassword,
  );

  // const [comForgetPassword, { loading }] = useMutation<any>(mutations.forgotPassword, {
  //   onCompleted: (data) => {
  //     const { comForgetPassword } = data;
  //     if (comForgetPassword.success === false) {
  //       setResetSuccess(false);
  //       setUserNotFound(comForgetPassword.userNotFound);
  //       onError(comForgetPassword.message);
  //     } else {
  //       setUserNotFound(false);
  //       setResetSuccess(true);
  //       onCompleted(data);
  //     }
  //   },
  //   onError: (error) => {
  //     setResetSuccess(false);
  //     onError(error.message);
  //   },
  // });

  const submit = useCallback(
    (variablesObject: { email: string }) => {
      try {
        const variables = {
          url: window.location.origin,
          ...variablesObject,
        };
        comForgetPassword({
          variables,
        })
          .then((data) => {
            let comForgetPassword = {};
            if (data?.data?.forgetPassword) {
              comForgetPassword = data?.data?.forgetPassword;
            } else if (data?.data?.comForgetPassword) {
              comForgetPassword = data?.data?.comForgetPassword;
            }
            if ((comForgetPassword as any).success === false) {
              setResetSuccess(false);
              setUserNotFound((comForgetPassword as any).userNotFound);
              onError((comForgetPassword as any).message);
            } else {
              setUserNotFound(false);
              setResetSuccess(true);
              onCompleted(data);
            }
          })
          .catch((error: unknown) => {
            setResetSuccess(false);
            onError(error instanceof Error ? error.message : String(error));
          });

        ReactGA.event({
          category: "Authentication",
          action: "PasswordReset",
          label: variables?.email.replace("@", "[at]"),
        });
      } catch (error: unknown) {
        onError(error instanceof Error ? error.message : String(error));
      }
    },
    [comForgetPassword, onCompleted, onError],
  );

  return {
    submit,
    isSubmitting: loading,
    resetSuccess,
    userNotFound,
  };
}
